import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import SaleReturnHeader from "../../components/SaleReturn/SaleReturnHeader";
import SaleReturnList from "../../components/SaleReturn/SaleReturnList";

const SaleReturnPage = () => {
  return (
    <div className="px-3 py-2">
      <Breadcrumb currentPage="Sale Return List" />
      <SaleReturnHeader />
      <SaleReturnList />
    </div>
  );
};

export default SaleReturnPage;
